// extracted by mini-css-extract-plugin
module.exports = {"disabled":"DateWidget_disabled__2Etgb"};